import { StandardEntity } from '../../engine/standard-entity';
import { Selectable } from '../../interface/selectable';
import { CheckState } from '../../enum/check-state.enum';
import { CommonUtils } from '../../tool/common-utils';

export class StandardListEntity extends StandardEntity implements Selectable {
  check: boolean;
  enable: boolean;
  checkState: CheckState = CheckState.uncheck;
  iconColor: string;
  items: StandardListEntity[] = [];
  normalizedText: string;

  get state(): CheckState {
    if (this.items.length === 0) {
      return this.checkState;
    }
    if (this.items.every((item) => item.state === CheckState.check)) {
      return CheckState.check;
    }
    if (this.items.every((item) => item.state === CheckState.uncheck)) {
      return CheckState.uncheck;
    }
    return CheckState.partial;
  }

  get isGroup(): boolean {
    return this.items.length > 0;
  }

  constructor(id: string, label: string, items: StandardListEntity[] = []) {
    super(id, label, 'full');
    this.items = items;
  }

  public toggleCheckState(checkState?: CheckState): void {
    if (this.state === CheckState.check || checkState === CheckState.uncheck) {
      this.uncheckItem();
      return;
    }
    this.checkItem();
  }

  public checkItem(): void {
    if (this.isGroup) {
      this.items.forEach((item) => item.checkItem());
    }
    this.checkState = CheckState.check;
  }
  public uncheckItem(): void {
    if (this.isGroup) {
      this.items.forEach((item) => item.uncheckItem());
    }
    this.checkState = CheckState.uncheck;
  }

  public getCheckedItems(items = []): StandardListEntity[] {
    if (this.isGroup) {
      this.items.forEach((item) => item.getCheckedItems(items));
    }
    if (this.checkState === CheckState.check && !this.isGroup) {
      items.push(this);
    }
    return items;
  }

  public flat(): StandardListEntity[] {
    const result: StandardListEntity[] = [];
    if (this.isGroup) {
      this.items.forEach((item) => {
        result.push(...item.flat());
      });
    }
    result.push(this);
    return result;
  }

  public search(value: string): boolean {
    return CommonUtils.normalize(this.toString(), true).includes(
      CommonUtils.normalize(value, true),
    );
  }

  public sort() {
    if (this.isGroup) {
      this.items.forEach((item) => item.sort());
    }
    this.items.sort((a, b) => a.label.localeCompare(b.label));
  }
}
